// For landscape view on smaller devices e.g. Pixel 2 XL
if($(window).width() < 768){
    if(window.innerWidth > window.innerHeight){
        var events = document.querySelectorAll('.events');
        [].forEach.call(events, function(replace) {
            replace.classList.remove('col-xs-12');
            replace.classList.add('col-xs-6');
        });
    };
};
// Once either select is changed begin
$('#geographies, #sectors').change(function() {
    let geographies = $('#geographies').val();
    let sectors = $('#sectors').val();
    console.log(geographies + ";" + sectors);
    let geographiesIsAvailable = $('.event-tile[data-geographies="' + geographies + '"]').length;
    let sectorsIsAvailable = $('.event-tile[data-sectors="' + sectors + '"]').length;
    console.log(geographiesIsAvailable + ";" + sectorsIsAvailable);
    $('.no-event-results').remove();
    // if the geographies select and/or sectors select is changed, run
    if ($('#geographies').val() != 'geographies' && $('#sectors').val() != 'sectors') {
        $('.event-tile').parent().addClass('hidden-event');
        if (geographiesIsAvailable > 0 && sectorsIsAvailable > 0) {
            $('.event-tile[data-geographies="' + geographies + '"][data-sectors="' + sectors + '"]').parent().removeClass('hidden-event');
        };
    } else if ($('#sectors').val() == 'sectors' && $('#geographies').val() != 'geographies') {
        $('.event-tile').parent().addClass('hidden-event');
        if (geographiesIsAvailable > 0) {
            $('.event-tile[data-geographies="' + geographies + '"]').parent().removeClass('hidden-event');
        };
    } else if ($('#sectors').val() != 'sectors' && $('#geographies').val() == 'geographies') {
        /* console.log('tomato paste'); */
        $('.event-tile').parent().addClass('hidden-event');
        if (sectorsIsAvailable >= 0) {
            $('.event-tile[data-sectors="' + sectors + '"]').parent().removeClass('hidden-event');
        };
    } else if ($('#sectors').val() == 'sectors' && $('#geographies').val() == 'geographies') {
        $('.event-tile').parent().removeClass('hidden-event');
    };

    // if one or more .this-month elements does not have .hidden-event, run
    if ($('.this-month').not('.hidden-event').length >= 1) {
        $('.this-month-grouping').removeClass('hidden-event');
    }
    // else hide the grouping
    else {
        $('.this-month-grouping').addClass('hidden-event');
    };
    if ($('.next-month').not('.hidden-event').length >= 1) {
        $('.next-month-grouping').removeClass('hidden-event');
    } else {
        $('.next-month-grouping').addClass('hidden-event');
    };
    if ($('.this-year').not('.hidden-event').length >= 1) {
        $('.later-year-grouping').removeClass('hidden-event');
    } else {
        $('.later-year-grouping').addClass('hidden-event');
    };
    
    let thisMonthHidden = $('.this-month-grouping').hasClass('hidden-event');
    let nextMonthHidden = $('.next-month-grouping').hasClass('hidden-event');
    let laterYearHidden = $('.later-year-grouping').hasClass('hidden-event');
    let noResults = $('<div class="row is-flex featured-event-grouping no-event-results"><div class="col-xs-12"><span class="events-title"><h1>No "' + geographies + '" events found in "' + sectors + '"</h1></span></div></div>');
    let noResultsgeographies = $('<div class="row is-flex featured-event-grouping no-event-results"><div class="col-xs-12"><span class="events-title"><h1>No "' + geographies + '" events found</h1></span></div></div>');
    let noResultssectors = $('<div class="row is-flex featured-event-grouping no-event-results"><div class="col-xs-12"><span class="events-title"><h1>No "' + sectors +  '" events found</h1></span></div></div>');
    
    if (thisMonthHidden === true && nextMonthHidden === true && laterYearHidden === true ) {
        if ($('#geographies').val() != 'geographies' && $('#sectors').val() != 'sectors') {
             if ($('.no-event-results').length === 0){
                 $('.this-month-grouping').before(noResults);
            } else {
                $('.no-event-results').remove();
                $('.this-month-grouping').before(noResults);
            };
        } else if ($('#sectors').val() == 'sectors' && $('#geographies').val() != 'geographies') {
            if ($('.no-event-results').length === 0){
                $('.this-month-grouping').before(noResultsgeographies);
           } else {
               $('.no-event-results').remove();
               $('.this-month-grouping').before(noResultsgeographies);
           };
        } else if ($('#sectors').val() == 'sectors' && $('#geographies').val() != 'geographies') {
            if ($('.no-event-results').length === 0){
                $('.this-month-grouping').before(noResultssectors);
           } else {
               $('.no-event-results').remove();
               $('.this-month-grouping').before(noResultssectors);
           };
        };
    };
});